import { render } from "./boyaaChinese.vue?vue&type=template&id=69cf421c&scoped=true"
import script from "./boyaaChinese.vue?vue&type=script&lang=js"
export * from "./boyaaChinese.vue?vue&type=script&lang=js"

import "./boyaaChinese.vue?vue&type=style&index=0&id=69cf421c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69cf421c"]])

export default __exports__